import { createSelector } from 'reselect';
import { RouteParams } from './customer.selectors';
import { pathOr } from 'ramda';
import { CoreLocaleKeys, i18n } from 'invision-core';
var recoverableUIStateSelector = function recoverableUIStateSelector(state) {
  return state.customercare.recoverableUiState.customerCouponsLists;
};
export var CouponStoreSelector = function CouponStoreSelector(state) {
  return state.customercare.coupon;
};
export var CouponRedemptionCodesSelector = createSelector([CouponStoreSelector], function (coupon) {
  return coupon.data ? coupon.data : {};
});
export var CurrentCouponRedemptionCodeIdentifierSelector = createSelector([CouponStoreSelector], function (coupon) {
  return coupon.searchResultId;
});
export var CurrentCouponRedemptionCodeSelector = createSelector([CouponRedemptionCodesSelector, CurrentCouponRedemptionCodeIdentifierSelector], function () {
  var couponCodeThumbnails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var currentCouponRedemptionCodeId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return couponCodeThumbnails[currentCouponRedemptionCodeId] ? couponCodeThumbnails[currentCouponRedemptionCodeId] : null;
});
export var CurrentCouponRedemptionCodeValueSelector = createSelector([CurrentCouponRedemptionCodeSelector], function (couponCodeThumbnail) {
  return couponCodeThumbnail.RedemptionCode.RedemptionCode;
});
export var CouponRedemptionCodeErrorSelector = createSelector([CouponStoreSelector], function (coupon) {
  return coupon.couponError;
});
export var SelectedReasonIdSelector = createSelector([CouponStoreSelector], function (coupon) {
  return coupon.selectedReasonId;
});
export var CurrentRedemptionDetailsSelector = createSelector([CouponRedemptionCodesSelector, RouteParams], function (couponRedemptionCodeDetails, routeParams) {
  return pathOr(null, [routeParams.couponRedemptionCodeId], couponRedemptionCodeDetails);
});
export var CurrentRedemptionCodeRedemptionsDataSelector = createSelector([CouponRedemptionCodesSelector], function (couponRedemptionCodes) {
  return pathOr(null, ['redemptionCodeRedemptionsData'], couponRedemptionCodes);
});
export var IsRedemptionCodeGlobalSelector = createSelector([CurrentRedemptionDetailsSelector], function (currentRedemptionCodeDetails) {
  if (currentRedemptionCodeDetails && currentRedemptionCodeDetails.RedemptionCode) {
    // All RedemptionCode objects with the Granted property WILL NOT be global
    return !currentRedemptionCodeDetails.RedemptionCode.Granted;
  }
  return false;
});
export var IsFetchingRedemptionCodeRedemptionsSelector = createSelector([CouponStoreSelector], function (couponStore) {
  return pathOr(false, ['isFetchingRedemptionCodeRedemptions'], couponStore);
});
export var RedemptionCodeRedemptionsRecordCountSelector = createSelector([CurrentRedemptionCodeRedemptionsDataSelector], function (redemptionData) {
  return pathOr(0, ['RecordCount'], redemptionData);
});
export var RedemptionCodeRedemptionsTotalPageNumberSelector = createSelector([CurrentRedemptionCodeRedemptionsDataSelector], function (redemptionData) {
  return pathOr(0, ['PageCount'], redemptionData);
});
export var RedemptionCodeRedemptionsCurrentPageNumberSelector = createSelector([recoverableUIStateSelector], function (uiState) {
  return pathOr(1, ['redemptionCodeRedemptionsCurrentPageNumber'], uiState);
});
export var RedemptionCodeRedemptionsSelectedPageSizeSelector = createSelector([recoverableUIStateSelector], function (redemptionData) {
  return pathOr(null, ['redemptionCodeRedemptionsRedemptionPageSizePreference'], redemptionData);
});
export var RedemptionCodeRedemptionsRedemptionDateEndFilterSelector = createSelector([recoverableUIStateSelector], function (uiState) {
  return pathOr(undefined, ['redemptionCodeRedemptionsRedemptionDateEndFilter'], uiState);
});
export var RedemptionCodeRedemptionsRedemptionDateStartFilterSelector = createSelector([recoverableUIStateSelector], function (uiState) {
  return pathOr(undefined, ['redemptionCodeRedemptionsRedemptionDateStartFilter'], uiState);
});
export var CurrentRedemptionCodeTableDataSelector = createSelector([CurrentRedemptionCodeRedemptionsDataSelector], function (redemptionCodeRedemptionsData) {
  var tableData = [];
  if (redemptionCodeRedemptionsData && redemptionCodeRedemptionsData.CouponRedemptions) {
    redemptionCodeRedemptionsData.CouponRedemptions.forEach(function (redemptionInstance) {
      var productPricingPlan;
      if (redemptionInstance.Product && redemptionInstance.PricingPlanName) {
        productPricingPlan = "".concat(redemptionInstance.Product.Name, "/").concat(redemptionInstance.PricingPlanName);
      } else {
        productPricingPlan = i18n.translate(CoreLocaleKeys.NOT_APPLICABLE);
      }
      tableData.push({
        RedemptionDate: redemptionInstance.RedemptionDate || i18n.translate(CoreLocaleKeys.NOT_APPLICABLE),
        Redeemer: redemptionInstance.SubscriberEmail || i18n.translate(CoreLocaleKeys.NOT_APPLICABLE),
        OrderId: redemptionInstance.OrderId || i18n.translate(CoreLocaleKeys.NOT_APPLICABLE),
        OrderNumber: redemptionInstance.OrderNumber || i18n.translate(CoreLocaleKeys.NOT_APPLICABLE),
        ProductPricingPlan: productPricingPlan,
        SubscriberId: redemptionInstance.SubscriberId || undefined
      });
    });
  }
  return tableData;
});